import React, { useEffect, useState } from 'react';
import { facialService } from '../../services/central-api/facial';
import { translate } from '../../services/translate';
import ExternalSelect from '../ExternalSelect';

interface Props {
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
    zIndex: number;
    readOnly?: boolean;
}

function TagsDropdown({ value, setValue, zIndex, readOnly }: Props) {
    const [items, setItems] = useState<{ label: string; value: number; }[]>([]);

    async function getTags() {
        try {
            const tags = await facialService.getSimplifiedFacialMarkers();

            setItems(tags.map((tag) => {
                return {
                    value: tag.id,
                    label: tag.name,
                    color: tag.color,
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        getTags();
    }, []);

    return (
        <ExternalSelect
            label={translate('tags')}
            selectedLabel={translate('selectedTags')}
            items={items}
            setValue={setValue}
            value={value}
            multiple={true}
            zIndex={zIndex}
            onRemove={(items) => setValue(items as number[])}
            initialSelectedItems={items.filter(item => value.includes(item.value))}
            readOnly={readOnly}
        />
    );
}

export default TagsDropdown;
